import React, { useMemo, useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import {
  Avatar,
  Typography,
  Box,
  TextField,
  Button,
} from "@mui/material";
import camera from '../../../../icons/camera.svg';
import profileService from "../../../../services/profile.service";
// import mime from "https://cdn.skypack.dev/mime";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { useFormik } from 'formik';
import * as yup from 'yup';
import { makeStyles, styled } from "@mui/styles";
import ClearIcon from "@mui/icons-material/Clear";
import IconButton from "@mui/material/IconButton";
const mime = require('mime');

const baseStyle = {
  transition: "all .24s ease-in-out",
};

const activeStyle = {
  borderColor: "#2196f3"
};

const acceptStyle = {
  borderColor: "#00e676"
};

const rejectStyle = {
  borderColor: "#ff1744"
};

const thumbsContainer = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  minWidth: "200px",
  minHeight: "200px",
  borderRadius: "50%"
};

const thumb = {
  display: "inline-flex",
  width: 200,
  height: 200,
};

const thumbInner = {
  display: "flex",
  minWidth: "200px",
  minHeight: "200px",
  overflow: "hidden",
  width: "100%",
  borderRadius: "50%"
};

const img = {
  display: "block",
  width: "100%",
  height: "100%",
  objectFit: "cover"
};
const styles = {
  path: {
    color: "#68717A",
  },
  icon: {
    color: "#6B6B6B",
    marginBottom: "-3px",
    marginRight: "10px",
  },
  link: {
    color: "#5DA196",
    cursor: "pointer",
  },
  end: {
    color: "#A3A3A3",
  },
  buttonFile: {
    position: "absolute",
    right: "1px",
    top: "1px",
    // bottom: "9px",
    background: "linear-gradient(0deg, #E5E9EC, #E5E9EC), #404349",
    borderLeft: "1px solid #CED4DA",
    "border-radius": "0px 4px 4px 0px",
    width: "100px",
    color: "#404349",
    fontSize: "16px",
    // lineHeight: "23.92px",
    fontWeight: "300"
  },
  buttonClear: {
    position: "absolute",
    right: "110px",
    top: "9px",
    color: "#404349",
    fontSize: "16px",
    fontWeight: "300"
  },
};

let acceptedFileItemsStatus = false;
let fileRejectionItemsStatus = false;

function UploadFiles(props) {
  const useStyles = makeStyles({
    iconContainer: {
      '& svg': {
        width: "45px",
        height: "45px"
      }
    },
    formTextField: {
      '& .MuiTextField-root': { m: 1, width: '25ch' },
    },
    input: {
      '& div > input': {
        height: '8px',
        position: "relative",
        "white-space": "nowrap",
        "text-overflow": "ellipsis",
        overflow: "hidden",
        width: "calc(100% - 140px)"
      }
    },

    inputError: {
      '& div > input': {
        color: "#CC6058",
        background: "#CC60581A",
        textAlign: "center",
        height: '6px',
        border: "1px solid #CC6058 !important",
        borderRadius: "4px"
      }
    },
    disabled: {
      '& div > input': {
        height: '8px',
        position: "relative"
      },
      '& .Mui-disabled': {
        '-webkit-text-fill-color': '#404349 !important',
        backgroundColor: "#FAFAFA"
      },
      '& .MuiOutlinedInput-notchedOutline': {
        border: "none"
      }
    },

  })
  const { t } = useTranslation();
  const classes = useStyles();
  const [isAlertFileOpen, openAlertFile] = React.useState(false);
  const [isAlert, openAlert] = React.useState(false);
  const [test, setTest] = React.useState(true);
  const [isSuccessDialogOpen, openConfirmDialog] = React.useState(false);
  const [isAcceptedFileItemsStatus, setAcceptedFileItemsStatus] = React.useState(false);
  const [isFileRejectionItemsStatus, setFileRejectionItemsStatus] = React.useState(false);
  const [files, setFiles] = useState([]);
  const [filesName, setFilesName] = useState('');
  const [status, setStatus] = useState('');
  const { typeFiles, isDialog } = props;
  const dispatch = useDispatch();
  const validationSchema = yup.object({
    file: yup.string().required(t('admin.inputForm.msgError.icon')),
  });
  const formik = useFormik({
    initialValues: {
      file: '',
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      // console.log(values,222);
      // handleSubmitFiles(values)
      // openAlert(false)
      // submit(values)
      // openSuccessAddDialog(true)
    },
  });
  const handleSubmitFiles = (files) => {
    props.sendFiles(files)
    openAlert(false)
  }
  const handleClearClick = () => {
    // setStatus(status)

    if (props.onClear) props.onClear()
    formik.setFieldValue("file", '')
    setFiles([])
  };
  const proxy = JSON.parse(localStorage.getItem("proxy"));
  const dataProfiles = JSON.parse(localStorage.getItem("user"));
  let permission = proxy?.proxy_token !== undefined ? proxy?.permission : dataProfiles?.permission
  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
    acceptedFiles,
    fileRejections,
    open
  } = useDropzone({
    // accept: "file/xlsx",
    noClick: true,
    noKeyboard: true,
    multiple: false,
    maxFiles: 1,
    // maxSize: 5242880,
    onDrop: acceptedFiles => {
      if (fileRejectionItemsStatus) {
        openAlert(true)
        // setFiles([])
      } else {
        acceptedFiles.map(file =>
          formik.setFieldValue("file", file.name)
          // setFilesName(file.name)
        )
        setFiles(
          acceptedFiles.map(file =>
            Object.assign(file, {
              preview: URL.createObjectURL(file),
            }),
          )
        );
        handleSubmitFiles(acceptedFiles)
        // formik.submitForm(acceptedFiles)
      }
    },
  });
  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {})
    }),
    [isDragActive, isDragReject]
  );

  const thumbs = files.map(file => (
    <div style={thumb} key={file.name}>
      <div style={thumbInner}>
        {/* <img src={file.preview} style={img} /> */}
        <Avatar
          src={file.preview}
          style={img}
          sx={{
            cursor: "pointer",
            width: 200,
            height: 200,
          }}
        />
      </div>
    </div>
  ));
  useEffect(
    () => () => {
      // Make sure to revoke the data uris to avoid memory leaks
      files.forEach(file => URL.revokeObjectURL(file.preview));
      let filename = files.map(file => (console.log(file, 79863)))
    },
    [files]
  );
  const acceptedFileItems = acceptedFiles.map(file => {
    let typesfile = mime.getExtension(file.type)
    let result = typeFiles.filter((rs) => (rs === typesfile))
    let type = result.toString()
    if (typesfile !== type) {
      fileRejectionItemsStatus = true
      acceptedFileItemsStatus = false
    } else {
      acceptedFileItemsStatus = false
      fileRejectionItemsStatus = false
    }
  });
  const update = () => {
    openAlertFile(false);
    // // openAlert(false)
    fileRejectionItemsStatus = false;
    acceptedFileItemsStatus = false;
  }
  return (
    <div className="container"  >
      <div {...getRootProps({ style })}>
        <input {...getInputProps()} />
        <div {...getRootProps({ style })}>
          <input {...getInputProps()} />
          <Box pb="20px" sx={{ width: isDialog ? "90%" : "100%", ".MuiFormControl-root": { marginTop: "7px" }, ".Mui-disabled": { "& fieldset": { borderColor: "#CED4DA" }, background: "#F3F3F3", WebkitTextFillColor: "#AAAAAA !important" }, margin: "0 40px" }}>
            <Typography variant="subtitle1" color="#404349" fontSize={18} fontWeight={500} lineHeight="24px" display="flex">Upload File <Box fontStyle="italic" sx={{ color: "#CC6058 " }}>*</Box></Typography>
            <Box sx={{
              position: "relative",
              marginTop: "7px",
              ".MuiFormControl-root": {
                marginTop: "0"
              }
            }}>
              <TextField
                error={Boolean(formik.touched.file && formik.errors.file)}
                fullWidth
                // helperText={"Supported format : xlsx"}
                margin="normal"
                name="file"
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                type="text"
                value={formik.values.file}
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                placeholder={'Choose file'}
                classes={{ root: classes.input }}
                inputProps={{ readOnly: true }}
                sx={{ ".MuiOutlinedInput-root": { color: "#404349", whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" } }}
              />
              <IconButton sx={{ visibility: formik.values.file ? "visible" : "hidden", zIndex: 2, padding: "5px", marginRight: "-5px", top: isDialog ? '8px !important' : null }} style={styles.buttonClear} onClick={() => handleClearClick()}><ClearIcon style={{ width: "15px", height: "15px" }} /></IconButton>
              <Button sx={{ padding: "5.5px 8px !important", textTransform: "capitalize", color: "#404349" }} style={styles.buttonFile} onClick={open}>{t('admin.inputForm.browse')}</Button>
            </Box>
            <div>{acceptedFileItems}</div>
            {/* <div>{fileRejectionItems}</div> */}
            <Typography variant="subtitle1" color="#939393" fontSize={14} fontWeight={300} lineHeight="20.93px" display="flex">Supported format : {typeFiles.toString()}</Typography>
            {isAlert ?
              <Typography fontSize={12} lineHeight="21px" color={"#CC6058"} sx={{ paddingTop: "0px" }}>{t(`label.uploadFailedPleaseTryAgain`)}</Typography>
              : null
            }
          </Box>
        </div>
      </div>
    </div >
  );
}

export default UploadFiles;
